import React from "react";
import { useTranslation } from "react-i18next";
import { TestimonialsData } from "../../data/testimonials-data";  

import "./testimonials.css";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-flip";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination, Navigation, EffectFlip } from "swiper/modules";

const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <section id="testimonials">
      <h4>{t("testimonials.subtitle")}</h4>
      <h2>{t("testimonials.title")}</h2>
      <Swiper
        className="container testimonials__container"
        spaceBetween={40}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        effect={""}
        modules={[Autoplay, Pagination, Navigation, EffectFlip]}
      >
        {TestimonialsData.map(({ id, avatar, name, reviewKey }) => {
          return (
            <SwiperSlide key={id} className="testimonial-slide">
              <div className="client__avatar">
                <img src={avatar} alt={t("testimonials.avatarAlt")} />
              </div>
              <h3 className="client__name">{t(`testimonials.clients.${name}`)}</h3>
              <h4 className="client__review">{t(`testimonials.reviews.${reviewKey}`)}</h4>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
